import { render, staticRenderFns } from "./SelectEmailTemplate.vue?vue&type=template&id=4956933a"
import script from "./SelectEmailTemplate.vue?vue&type=script&lang=js"
export * from "./SelectEmailTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports